import { createAsyncThunk } from '@reduxjs/toolkit';
import { storeResources } from '../../resources';
import { sendChatAttachment } from '../../../services/chats';
import { IChatMessage } from '../../../services/chats/types';

interface IProps {
  chatId: number;
  file: File;
}

export const ThunkSendChatAttachment = createAsyncThunk<IChatMessage, IProps>(
  `${storeResources.CHATS}/sendChatAttachment`,
  ({ chatId, file }) => {
    const formData = new FormData();
    formData.append('file', file);

    return sendChatAttachment(chatId, formData, file.type).then(res => res.data);
  },
);
